import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("plst_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function saveToken(token) {
  localStorage.setItem("plst_token", token);
}
export function clearToken() {
  localStorage.removeItem("plst_token");
}
export function getToken() {
  return localStorage.getItem("plst_token");
}
